
/* eslint-disable no-unused-vars */

import { Student } from '@/config'
import { defineComponent, PropType } from 'vue'
import { normalizeForSearch } from '@/utils'

export default defineComponent({
  name: 'Student',
  props: {
    student: {
      type: Object as PropType<Student>,
      required: true,
    },
  },
  // eslint-disable-next-line vue/no-setup-props-destructure
  setup({ student }) {
    return {
      ...student,
      picture: normalizeForSearch(`/pictures/${student.group}/${student.lastName}_${student.firstName}.jpg`),
    }
  },
})
